import { ReactElement, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { AuthActions } from 'state/authentication/Action';
import { HeadTag } from 'shared/components';

const ShareTemplateConfirmationStatus = (props: any): ReactElement => {
    const { status } = useParams();
    const { state } = useLocation();
    const {
        doLogout,
    }: {
        doLogout: (data: any) => void;
    } = props;

    // Hooks
    useEffect(() => {
        doLogout({});
    }, []);

    // UI Elements
    return (
        <>
            <HeadTag title="Share Invitation" />

            {status === 'accepted' && (
                <Box className="share-template-invite-wrapper">
                    <CheckCircleIcon className="check-circle-style" />

                    <Typography variant="h1" className="my-1 title">
                        Thank you, <br />
                        You have successfully accepted the shared template
                    </Typography>
                </Box>
            )}

            {status === 'rejected' && (
                <Box className="share-template-invite-wrapper">
                    <CheckCircleIcon className="check-circle-style" />
                    <Typography variant="h1" className="my-1 title">
                        Thank you, <br />
                        You have successfully rejected the shared template{' '}
                    </Typography>
                </Box>
            )}

            {status === 'error' && (
                <Box className="share-template-invite-wrapper">
                    <ErrorIcon className="error-icon-style" />

                    <Typography variant="h1" className="my-1 title">
                        {state || 'Session expired'}
                    </Typography>
                </Box>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch: any): any => ({
    doLogout: (data: any) => dispatch(AuthActions.doLogout(data)),
});

export default connect(
    null,
    mapDispatchToProps
)(ShareTemplateConfirmationStatus);
